import { render, staticRenderFns } from "./GravitationalTimeDilationViz.vue?vue&type=template&id=fb8f60cc&scoped=true"
import script from "./GravitationalTimeDilationViz.vue?vue&type=script&lang=js"
export * from "./GravitationalTimeDilationViz.vue?vue&type=script&lang=js"
import style0 from "./GravitationalTimeDilationViz.vue?vue&type=style&index=0&id=fb8f60cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8f60cc",
  null
  
)

export default component.exports